
import { Component, OnInit, ViewEncapsulation } from '@angular/core'
import { IQuestionContextView } from '..'
import { Question} from '../../../../../data/models'
import { Form} from '../../../../../forms/models'


@Component({
  selector: 'mp-tabbed-question-context-view.component',
  templateUrl: './tabbed-question-context-view.html',
  styleUrls: ['./tabbed-question-context-view.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TabbedQuestionContextViewComponent implements IQuestionContextView, OnInit {
  public question: Question
  public form: Form<Question>
  public item : Array<any>
  public tabQuestiondata: Array<{}>

  public ngOnInit(): void {
    this.tabQuestiondata = JSON.parse(this.question.questionContext.description)
  }
}




// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/angular/components/question-view/question-context-view/tabbed-question-context-view/tabbed-question-context-view.component.ts